const baseUrl = process.env.REACT_APP_BASE_URL || '';
const config = { baseUrl, LOG_ON: false };
export default config;
